<style src="css/userDetails.css" scoped></style>
<template>
    <div style="padding-top: .98rem">
        <div class="topbar-wrapper">
            <div class="topbar">
                <span class="back" @click="back"></span>
                预约详情
            </div>
        </div>
        <div class="bg">
            <div class="mainBox">
                <div class="userTop">
                    <div class="nameBox">
                        <div class="userImg"></div>
                        {{doctorBespeakDetail.userName}}
                    </div>
                    <div class="statusBtn">{{doctorBespeakDetail.scaleUserBespeak.status | isStatus}}</div>
                </div>
                <div class="titleBox">
                    <div class="titleLine"></div>
                    预约信息
                </div>
                <div class="infoBox">
                    预约老师：
                    <span>{{doctorBespeakDetail.doctorName}}</span>
                </div>
                <div class="infoBox">
                    咨询方式：
                    <span>{{doctorBespeakDetail.scaleUserBespeak.serveType | isServeType}}</span>
                </div>
                <div class="infoBox">
                    咨询次数：
                    <span>{{doctorBespeakDetail.scaleUserBespeak.bespeakTimes}}次</span>
                </div>
                <div class="infoBox">
                    预约时间：
                    <span>{{doctorBespeakDetail.scaleUserBespeak.bespeakDate}}</span>
                </div>
                <div class="infoBox">
                    问题类型：
                    <div class="infoRight" v-if="doctorBespeakDetail.scaleUserBespeak.troubles != undefined">
                        <span v-for="item in JSON.parse(doctorBespeakDetail.scaleUserBespeak.troubles)">{{item}}</span>
                    </div>
                </div>

                <div v-if="doctorBespeakDetail.scaleUserBespeakRegister">
                    <div class="titleBox">
                        <div class="titleLine"></div>
                        来访者信息
                    </div>
                    <div class="infoBox" v-if="doctorBespeakDetail.mipStudentDetail != null">
                        性别
                        <span>{{doctorBespeakDetail.mipStudentDetail.studentGender}}</span>
                    </div>
                    <div class="infoBox" v-if="doctorBespeakDetail.mipStudentDetail != null">
                        学历
                        <span>{{doctorBespeakDetail.mipStudentDetail.grade}} {{doctorBespeakDetail.mipStudentDetail.degree}}</span>
                    </div>
                    <div class="infoBox" v-if="doctorBespeakDetail.mipStudentDetail != null">
                        年龄
                        <span>{{doctorBespeakDetail.mipStudentDetail.userAge}}</span>
                    </div>
                    <div class="infoBox" v-if="doctorBespeakDetail.mipStudentDetail != null">
                        校区学院
                        <span>{{doctorBespeakDetail.mipStudentDetail.campus}} {{doctorBespeakDetail.mipStudentDetail.faculty}}</span>
                    </div>
                    <div class="infoBox">
                        出生地
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.birthPlace | isBirthPlace}}</span>
                    </div>
                    <div class="infoBox">
                        是否独生子女
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.onlyChild | isOnlyChild}}</span>
                    </div>
                    <div class="infoBox">
                        宗教信仰
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.religiousBeliefs | isReligiousBeliefs}}</span>
                    </div>
                    <div class="infoBox itemStatus">
                        在杭住址(寝室或外宿地址)
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.address}}</span>
                    </div>
                    <div class="titleBox mb3">
                        <div class="titleLine"></div>
                        家庭状况
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">父亲年龄 <input type="number" disabled v-model="doctorBespeakDetail.scaleUserBespeakRegister.fatherAge" class="minInput"> 岁</div>
                        <div class="itemRight">
                            健在
                            <div class="radioBox">
                                <div class="radioIcon" :class="{active:doctorBespeakDetail.scaleUserBespeakRegister.fatherLive === 0}"></div>
                                是
                            </div>
                            <div class="radioBox">
                                <div class="radioIcon" :class="{active:doctorBespeakDetail.scaleUserBespeakRegister.fatherLive === 1}"></div>
                                否
                            </div>
                        </div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">职业 <input type="text" disabled v-model="doctorBespeakDetail.scaleUserBespeakRegister.fatherWork" class="medium"></div>
                        <div class="itemRight">
                            学历
                            <input type="text" disabled v-model="doctorBespeakDetail.scaleUserBespeakRegister.fatherEducation" class="minInput">
                        </div>
                    </div>
                    <div class="infoItem">
                        <div class="infoKey">母亲年龄 <input disabled type="number" v-model="doctorBespeakDetail.scaleUserBespeakRegister.motherAge" class="minInput"> 岁</div>
                        <div class="itemRight">
                            健在
                            <div class="radioBox">
                                <div class="radioIcon" :class="{active:doctorBespeakDetail.scaleUserBespeakRegister.motherLive === 0}"></div>
                                是
                            </div>
                            <div class="radioBox">
                                <div class="radioIcon" :class="{active:doctorBespeakDetail.scaleUserBespeakRegister.motherLive === 1}"></div>
                                否
                            </div>
                        </div>
                    </div>
                    <div class="infoItem mb0">
                        <div class="infoKey">职业 <input type="text" disabled v-model="doctorBespeakDetail.scaleUserBespeakRegister.motherWork" class="medium"></div>
                        <div class="itemRight">
                            学历
                            <input type="text" disabled v-model="doctorBespeakDetail.scaleUserBespeakRegister.motherEducation" class="minInput">
                        </div>
                    </div>
                    <div class="infoBox">
                        父母婚姻状况
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.parentMarital | isParentMarital}}</span>
                    </div>
                    <div class="infoBox">
                        家庭经济条件
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.familyEconomic | isFamilyEconomic}}</span>
                    </div>
                    <div class="infoBox">
                        家族精神类疾病史
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.familyMentalIllness | isFamilyMentalIllness}}</span>
                    </div>

                    <div class="titleBox">
                        <div class="titleLine"></div>
                        个人状况
                    </div>

                    <div class="infoBox">
                        对本专业的满意度
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.majorSatisfaction | isMajorSatisfaction}}</span>
                    </div>
                    <div class="infoBox">
                        <div class="mw4">
                            近一年来，是否经历了重大负性生活事件(如亲友的离去、失恋、考试失败等)?
                        </div>

                        <span class="mw2">{{doctorBespeakDetail.scaleUserBespeakRegister.incident | isIncident}}</span>
                    </div>

                    <div class="infoBox">
                        您是否曾自伤或自杀
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.selfInflicted | isSelfInflicted}}</span>
                    </div>
                    <div class="infoBox">
                        个人精神疾病史
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.selfMentalIllness | isSelfMentalIllness}}</span>
                    </div>
                    <div class="infoBox">
                        咨询经历
                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.consultHistory | isConsultHistory}}</span>
                    </div>
                    <div class="infoBox">
                        <div class="mw4">评估目前压力水平（请打分，10分水平最高）</div>

                        <span>{{doctorBespeakDetail.scaleUserBespeakRegister.pressureValue | isPressureValue}}</span>
                    </div>

                    <div class="titleBox">
                        <div class="titleLine"></div>
                        紧急联系人
                    </div>
                    <div class="infoBox">
                        姓名：
                        <span>{{doctorBespeakDetail.scaleUserBespeakAgree.emergencyContact}}</span>
                    </div>
                    <div class="infoBox">
                        关系：
                        <span>{{doctorBespeakDetail.scaleUserBespeakAgree.relation}}</span>
                    </div>
                    <div class="infoBox">
                        联系电话：
                        <span>{{doctorBespeakDetail.scaleUserBespeakAgree.emergencyContactPhone}}</span>
                    </div>
                </div>


            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                bespeakId:'',
                doctorBespeakDetail:{
                    scaleUserBespeak:{}
                }
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },

            isStatus(v){
                let arr = ['预约中','待咨询','进行中','已完成','已取消']
                return arr[v]
            },

            isServeType(v){
                let arr = ['图文咨询','电话咨询','视频咨询','线下咨询']
                return arr[v]
            },
            isBirthPlace(v){
                let arr = ['农村','城市']
                return arr[v]
            },
            isParentMarital(v){
                let arr = ['良好','一般','离婚','再婚']
                return arr[v]
            },
            isFamilyEconomic(v){
                let arr = ['优越','一般','贫困']
                return arr[v]
            },
            isFamilyMentalIllness(v){
                let arr = ['无','有']
                return arr[v]
            },
            isConsultHistory(v){
                let arr = ['无','有']
                return arr[v]
            },
            isPressureValue(v){
                return v+'分'
            },
            isMajorSatisfaction(v){
                let arr = ['非常满意','比较满意','一般','不太满意','非常不满意','无所谓']
                return arr[v]
            },
            isSelfInflicted(v){
                let arr = ['否','自伤或自杀想法','自伤行为','自杀行为']
                return arr[v]
            },
            isOnlyChild(v){
                if(v===0){
                    return '是'
                }else if(v > 0){
                    return  `家中排行 ${v}`
                }
            },
            isReligiousBeliefs(v){
                if(v==='0'){
                    return '无'
                }else {
                    return  v
                }
            },
            isIncident(v){
                if(v==='0'){
                    return '无'
                }else {
                    return  v
                }
            },
            isSelfMentalIllness(v){
                if(v==='0'){
                    return '无'
                }else {
                    return  v
                }
            }
        },
        computed: {},
        methods: {
            back() {
                history.back()
            },

            async getDoctorBespeakDetail() {
                let obj = {}
                obj.bespeakId = this.bespeakId;
                obj.doctorId = localStorage.getItem('doctorId');
                let data = await getSources("/bear-scale/api/scaleUserBespeak/getDoctorBespeakDetail.json", obj);
                if (data.status === 0) {
                    this.doctorBespeakDetail=data.doctorBespeakDetail;
                }else{
                    alert(data.msg)
                }
            },
        },
        destroyed(){

        },
        mounted() {
            this.bespeakId=this.$route.query.bespeakId;
            this.getDoctorBespeakDetail()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/userDetails.vue